document.addEventListener("DOMContentLoaded", function () {
  var descriptionText = document.querySelector(".short-description-text");
  var readMoreBtn = document.querySelector(".read-more");

  if (!descriptionText || !readMoreBtn) return;

  // Check if the content overflows (more than 4 lines)
  if (descriptionText.scrollHeight > descriptionText.clientHeight) {
    // Show the "Read More" button if content exceeds 4 lines
    readMoreBtn.style.display = "";
  }

  // Handle the Read More / Read Less functionality
  readMoreBtn.addEventListener("click", function () {
    descriptionText.classList.toggle("expanded");
    readMoreBtn.textContent = descriptionText.classList.contains("expanded") ? "Read Less" : "Read More";
  });
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    // Check if an element with class "Kali" or "Normal" exists
    const isTargetPage = document.querySelector('.Kali, .Normal');

    if (isTargetPage) {
      // Select all h4 elements with the class "f-quantity-breaks__card-title"
      const titles = document.querySelectorAll('h4.f-quantity-breaks__card-title');

      titles.forEach((title) => {
        // Replace "Mtr." with "pcs" in the text content
        title.textContent = title.textContent.replace(/\bMtr\.\b/g, 'pcs');
      });
    }
  }, 1000);
});


document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("openPopup");
  const closeBtn = document.getElementById("closePopup");
  const popupOverlay = document.getElementById("popupOverlay");
  const body = document.body;

  // Ensure modal is hidden by default
  popupOverlay.style.display = "none";

  // Function to open the modal
  openBtn.addEventListener("click", function () {
    console.log("clicked");
    popupOverlay.style.display = "flex"; // Show modal
    body.classList.add("careers-modal-open"); // Add class to body
  });

  // Function to close the modal
  function closePopup() {
    popupOverlay.style.display = "none"; // Hide modal
    body.classList.remove("careers-modal-open"); // Remove class from body
  }

  // Close modal when clicking the close button
  closeBtn.addEventListener("click", closePopup);

  // Close modal when clicking outside of the modal content
  popupOverlay.addEventListener("click", function (event) {
    if (event.target === popupOverlay) {
      closePopup();
    }
  });
});

// disable right click on image
document.addEventListener("contextmenu", function (event) {
  if (event.target.tagName.toLowerCase() === "img") {
    event.preventDefault();
  }
});

const containers = document.querySelectorAll(".zoom-container");

containers.forEach((container) => {
  const img = container.querySelector(".zoom-image");
  const result = container.querySelector(".zoom-result");
if(result){
  result.style.backgroundImage = `url('${img.src}')`;
}
  img.addEventListener("mousemove", (e) => {
    result.style.display = "block";

    const bounds = img.getBoundingClientRect();
    const x = e.clientX - bounds.left;
    const y = e.clientY - bounds.top;

    const percentX = (x / img.width) * 100;
    const percentY = (y / img.height) * 100;

    result.style.backgroundPosition = `${percentX}% ${percentY}%`;
  });

  img.addEventListener("mouseleave", () => {
    result.style.display = "none";
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const originalFetch = window.fetch;
  window.fetch = async function (resource, config) {
    const isCartUpdate = typeof resource === 'string' && resource.includes('/cart/');

    const response = await originalFetch.apply(this, arguments);

    if (isCartUpdate) {
      setTimeout(() => {
        const target = document.getElementById('cart-drawer-form');
        if (!target) return;

        fetch(location.href)
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newForm = doc.getElementById('cart-drawer-form');
            if (newForm) {
              target.innerHTML = newForm.innerHTML;
            }
          });
      }, 2000);
    }

    return response;
  };
});